import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { SkillBar } from './SkillBar';
import { MetricCard } from './MetricCard';
export function SkillsSection() {
  const ref = useRef<HTMLElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const skillCategories = [{
    title: 'Programming & Databases',
    color: 'teal' as const,
    skills: [{
      name: 'Python',
      level: 95
    }, {
      name: 'MySQL',
      level: 90
    }, {
      name: 'Datawarehouse',
      level: 90
    }, {
      name: 'Git & GitHub',
      level: 90
    }]
  }, {
    title: 'Data Analysis & Visualization',
    color: 'orange' as const,
    skills: [{
      name: 'Excel',
      level: 95
    }, {
      name: 'Power BI',
      level: 90
    }, {
      name: 'Tableau',
      level: 85
    }]
  }, {
    title: 'Frameworks & Tools',
    color: 'purple' as const,
    skills: [{
      name: 'FastAPI',
      level: 85
    }, {
      name: 'Flask',
      level: 85
    }, {
      name: 'Django',
      level: 80
    }, {
      name: 'Streamlit',
      level: 90
    }, {
      name: 'Airflow',
      level: 80
    }, {
      name: 'Linux',
      level: 80
    }]
  }];
  return <section ref={ref} className="w-full py-24 px-6 bg-slate-900" id="skills" data-id="element-137">
      <div className="max-w-7xl mx-auto" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-139">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-slate-100" data-id="element-140">
            Technical Skills
          </h2>
          <p className="text-lg text-slate-400 font-mono" data-id="element-141">
            {'>'} Data-driven expertise across the analytics stack
          </p>
        </motion.div>

        {/* Metrics Overview */}
        
        {/* Skills Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-142">
          {skillCategories.map((category, categoryIndex) => <motion.div key={category.title} initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: -30
        }} transition={{
          duration: 0.6,
          delay: 0.6 + categoryIndex * 0.1
        }} className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 backdrop-blur-sm" data-id="element-143">
              <h3 className="text-xl font-bold mb-6 text-slate-200" data-id="element-144">
                {category.title}
              </h3>
              <div className="space-y-4" data-id="element-145">
                {category.skills.map((skill, skillIndex) => <SkillBar key={skill.name} name={skill.name} level={skill.level} color={category.color} delay={0.8 + categoryIndex * 0.1 + skillIndex * 0.05} data-id="element-146" />)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}